import { render, staticRenderFns } from "./appFileDropper.vue?vue&type=template&id=0f9a1283&scoped=true"
import script from "./appFileDropper.vue?vue&type=script&lang=js"
export * from "./appFileDropper.vue?vue&type=script&lang=js"
import style0 from "./appFileDropper.vue?vue&type=style&index=0&id=0f9a1283&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9a1283",
  null
  
)

export default component.exports